import { configure, makeAutoObservable  } from 'mobx'
import { updateDesign } from '../services/DesignService';
import { getBase } from '../utils/requests';

configure({
    enforceActions: "never",
})

class SaveStore {
  constructor(workAreaStore, authStore){
   makeAutoObservable(this)  
   this.workAreaStore = workAreaStore
   this.authStore = authStore
  }

  canSave = true

  setCanSave(status){
    this.canSave = status
  }

  //Convert number into hex string
  componentToHex(c) {
    const num = Number(c)
    var hex = num.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  rgbToHex(color){
    const [r, g, b] = color.split(', ')
    return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b)
  }

  updateTextLayers(textLayers){
    const updated = []
    if(!textLayers.length){
      return updated
    }
    textLayers.forEach(layer => {
      const selector = `.workarea-tools__text-layer.${btoa(layer.id)} p`
      const parentElements = document.querySelectorAll(selector)
      if(!parentElements.length){
        copy.remove = true
        return copy
      }
      const copy = { ...layer }
      copy.colors = []
      let prevStart = 0
      let copyContent = ''
      copy.content = ''
      let set = false
      parentElements.forEach((parent, idx) => {
        parent.childNodes.forEach((child, childIdx) => {
            //If the cursor is set at the beginning of the text layer
            if(child.querySelector('.ql-cursor') && copy.content === ''){
              return
            }
            //If there is more than 1 P element OR the cursor is set at a new line
            if((idx > 0 && childIdx === 0) || (child.querySelector('.ql-cursor'))){
              const last = copy.colors[copy.colors.length - 1]
              if(last && copy.content.trim().length > 0){
                copyContent += '\n'
                last.deltaEnd += 1
                prevStart += 1
                set = true
              }
            }
            const childTextContent = child.innerText
            const nodename = child.nodeName
            //If there is a breakline at the start of the text
            if(nodename === 'BR' && copy.content.trim().length === 0){
              copyContent = ''
              prevStart = 0
              return
            }
            //After the breaklines are rendered have to check if there are breaklines when the text component mounts again
            if(idx === 0 && !set && childTextContent === '\n'){
              copyContent += '\n'
              const last = copy.colors[copy.colors.length - 1]
              if(last){
                last.deltaEnd += 1
                prevStart += 1
              }
              return
            }
            //console.log(nodename, child, childTextContent)
            copyContent += childTextContent
            let end = (childTextContent.length - 1) + prevStart
            let hexColor = '#222222'
            if(nodename === 'SPAN' || nodename === 'STRONG' || nodename === 'EM' || nodename === 'U'){
              const shadowVal = child.style.textShadow
              child.style.textShadow = 'none'
              const styleAttr = child.getAttribute('style')
              const regexp = /\(([^)]+)\)/
              const matches = regexp.exec(styleAttr)
              if(matches && matches.length){
                const colorAttribute = matches[1]
                hexColor = this.rgbToHex(colorAttribute)
              }
              child.style.textShadow = shadowVal
            }
            copy.color = hexColor
            copy.colors.push({
              color: hexColor,
              deltaStart: prevStart,
              deltaEnd: end
            })
            prevStart = end + 1
          })
        copy.content += copyContent
        copyContent = ''
      })
      copy.content = copy.content.trim()
      updated.push(copy)
    })
    return updated
  }

  saveDesignLocally(design){
    if(!this.workAreaStore.invalidPermissionsModal){
      window.localStorage.setItem('designId', design.id)
      window.localStorage.setItem('design', JSON.stringify(design))
    }
  }

  async saveDesign(override = false, generatePreview = false, authorSave = false, forceSave = false, isExit = false){
    if((!this.workAreaStore.changed && !override && !forceSave) || this.workAreaStore.editingTextId || this.workAreaStore.saving){
      return false
    }
    if(this.workAreaStore.isPublic && !authorSave && !this.workAreaStore.canEditTeam){
      return
    }
    if(this.workAreaStore.resizingPage){
      return
    }
    const { auth, role } = this.authStore
    const isAdmin = auth && role.level && (role.level > 1)
    if(isAdmin && !authorSave && !forceSave && !isExit){
      return
    }
    const layers = this.workAreaStore.getAllLayers()
    const textLayers = layers.filter(({ type }) => type === 'text')
    const updatedTextLayers = this.updateTextLayers(textLayers)
    if(updatedTextLayers){
      updatedTextLayers.forEach(layer => {
        const idx = layers.findIndex(({ id }) => id === layer.id)
        if(idx > -1){
          if(layers[idx].remove){
            layers.splice(idx, 1)
          }else{
            layers[idx] = layer
          }
        }
      })
    }
    this.workAreaStore.pages.forEach((page, pageIdx) => {
      page.scale = this.workAreaStore.scale
      page.layers.forEach((layer, idx) => {
        const savedLayer = layers.find(({ id }) => id === layer.id)
        if(savedLayer){
          this.workAreaStore.pages[pageIdx].layers[idx] = savedLayer
        }
      })
    })
    //Do async ajax call and save design
    const design = {
      pages: this.workAreaStore.pages,
      id: this.workAreaStore.designId,
      title: this.workAreaStore.title,
      baseTemplate: this.workAreaStore.baseTemplate
    }
    try{
      this.workAreaStore.setSaving(true)
      const canEdit = this.authStore.auth || this.workAreaStore.publicPermissions === 'edit' || this.workAreaStore.canEditTeam
      if(canEdit){
        if(window.localStorage.getItem('design')){
          window.localStorage.removeItem('design')
          window.localStorage.removeItem('designId')
        }
        if(this.authStore.downloadLoading){
          return
        }
        if(isExit){
          const blob = new Blob([JSON.stringify(design)], {type : 'application/json; charset=UTF-8'})
          navigator.sendBeacon(`${getBase()}/design/save?isExit=${isExit}&forceSave=${forceSave}&generate=${generatePreview}`, blob)
        }else{
          const res = await updateDesign(design, generatePreview, forceSave)
          if(res.data && !res.data.empty){
            this.workAreaStore.setEmptySaved(false)
            this.workAreaStore.isOwner = res.data.isOwner
            this.workAreaStore.designRoles = res.data.roles.map(role => role.role)
            this.workAreaStore.shared = res.data.shared
          }
          if(res.data.empty){
            this.workAreaStore.setEmptySaved(true)
          }
          this.workAreaStore.setSaved(true)
        }
      }else{
        this.saveDesignLocally({
          ...design, 
          groups: this.workAreaStore.groups,
          toolbars: this.workAreaStore.textStyleToolbars,
          title: this.workAreaStore.title
        })
        this.workAreaStore.setSaved(true)
      }
      this.workAreaStore.setChanged(false)
    }catch(e){
      console.log(e)
      this.workAreaStore.setSaving(false)
      return false
    }finally {
      this.workAreaStore.setSaving(false)
      return true
    }
  }

}

export default SaveStore